/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/15/2019.
 */

import {object, string} from 'yup'

export const faultCloseModel = (intl) => {
    return object().shape({
        comment: string().required(intl.formatMessage({id: "fault.schema.close.comment.required"})),
        commentText: string().when('comment', {
            is: 'Other',
            then: (comment) => comment.required(intl.formatMessage({id: "fault.schema.close.comment.required.text"})),
            otherwise: (comment) => comment.notRequired()
        }),
    })
}

